import { render, staticRenderFns } from "./news.vue?vue&type=template&id=1c40cbb0&scoped=true"
import script from "./news.detail.js?vue&type=script&lang=js&external"
export * from "./news.detail.js?vue&type=script&lang=js&external"
import style0 from "./news.vue?vue&type=style&index=0&id=1c40cbb0&prod&class=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c40cbb0",
  null
  
)

export default component.exports